import React from "react";
import { useTranslation } from "react-i18next";

export function ConfirmationModal({ isOpen, onConfirmClose }) {
  const { t } = useTranslation("signup");

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">

      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-[#2F302C99] backdrop-blur-[2px]"
        onClick={onConfirmClose}
      />

      {/* Modal */}
      <div className="relative bg-white w-full max-w-xl rounded-2xl shadow-2xl p-10 text-center animate-in fade-in zoom-in duration-300">

        {/* Watermark Logo */}
        <div
          className="absolute inset-0 opacity-5 pointer-events-none flex items-center justify-center"
          style={{
            backgroundImage: `url('/img/logos/logo.png')`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundSize: "45%",
          }}
        />

        <div className="relative z-10">

          {/* Message */}
          <p className="text-lg text-[#2F302C] font-medium leading-relaxed">
            {t("reviewMessage")}
            <br />
            {t("approvalMessage")}
          </p>

          {/* Button */}
          <div className="mt-8 flex justify-center">
            <button
              onClick={onConfirmClose}
              className="px-40 py-3 rounded-xl border 
                         border-[#F4B11F] 
                         text-[#F4B11F] 
                         font-semibold
                         hover:bg-[#F4B11F] 
                         hover:text-white
                         transition-all duration-300
                         active:scale-95"
            >
              {t("understood")}
            </button>
          </div>

        </div>
      </div>
    </div>
  );
}

export default ConfirmationModal;